import React, { lazy, Suspense } from 'react';
import PublicRoute from '../../../routes/PublicRoute';
import PrivateRoute from '../../../routes/PrivateRoute';
import { Spinner } from '../../Common/Spinner';

const FacultyListTable = lazy(() => import('./List/FacultyListTable'));
const FacultyForm = lazy(() => import('./FacultyForm'));
const FacultyInstructionPage = lazy(() => import('./FacultyInstructionPage'));
const FacultyProfilePage = lazy(() => import('./FacultyProfilePage'));

const FacultyRouter = (props) => (
  <Suspense fallback={<Spinner />}>
    <PrivateRoute path="/list/faculties" searchString={props.searchString} formId={1307} component={FacultyListTable} exact />
    <PrivateRoute path="/list/non/faculties" searchString={props.searchString} formId={1318} component={FacultyListTable} exact />
    <PrivateRoute path="/faculty/profile/:id" component={FacultyProfilePage} exact />

    <PublicRoute path="/faculty/new/:organization_id/:id?" formId={1307} component={FacultyForm} exact />
    <PublicRoute path="/non/faculty/new/:organization_id/:id?" formId={1318} component={FacultyForm} exact />
    <PublicRoute path="/faculty/registration/instruction/:organization_id" formId={1307} component={FacultyInstructionPage} exact />
    <PublicRoute path="/non/faculty/registration/instruction/:organization_id" formId={1318} component={FacultyInstructionPage} exact />
  </Suspense>
);

export default FacultyRouter;